import { ActionHandler } from 'action-handler';

export default new ActionHandler({
  name: 'direction',
  stateProp: 'direction',
  defaultState: {
    direction: 'LOADING'
  },
  handler(direction) {
    return { direction };
  },
  reduce: (state, { direction }) => ({
    direction
  })
});
